<template>
  <div class="c-month-picker">
    <div v-if="datePicker" class="shadow" @click="datePicker = false" />
    <div class="date-place-wrap">
      <div class="date-picker-place" @click.stop="datePicker = true">
        <div class="icon" @click.stop="decMonth">
          <img :src="left" alt="" />
        </div>
        <div class="title-place">
          <div class="image-place">
            <img :src="imgCalendar" alt="">
          </div>
          <div class="title">{{ months[month] }} {{ cYear }}</div>
        </div>
        <div class="icon">
          <img :src="right" alt="" @click.stop="incMonth" />
        </div>
      </div>
  
      <div v-if="datePicker" class="month-picker-popover">
        <div class="top-row">
          <div class="arrow" @click="cYear--"><img :src="left" alt="" /></div>
          <div class="year">{{ cYear }}</div>
          <div class="arrow" @click="cYear++"><img :src="right" alt="" /></div>
        </div>
        <div class="month-grid">
          <div
            v-for="(m, index) in months"
            :key="index"
            :class="['month-cell', { active: index === month }]"
            @click="selectMonth(index)"
          >
            {{ m }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import imgCalendar from '../../assets/new/calendar-icon.svg'
import left from '../../assets/new/left-icon.svg'
import right from '../../assets/new/right-icon.svg'

export default {
  name: 'CMonthPicker',
  props: {
    value: {
      type: Number,
      default() {
        return new Date().getMonth()
      },
    },
    year: {
      type: Number,
      default() {
        return new Date().getFullYear()
      },
    },
  },
  data() {
    return {
      imgCalendar,
      left,
      right,
      datePicker: false,
      month: null,
      months: [],
      cYear: new Date().getFullYear(),
      localeMonths: {
        ru: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь', ],
        kz: [ 'Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан', ],
      },
    }
  },
  watch: {
    value() {
      this.month = this.value
    },
  },
  created() {
    const lang = $app.store.getter('app.lang') || 'ru'
    this.months = this.localeMonths[lang]
    this.month = this.value
    this.cYear = this.year
  },
  methods: {
    incMonth() {
      if (this.month + 1 > 11) {
        this.month = 0
        this.cYear += 1
      } else {
        this.month += 1
      }
      this.selectMonth(this.month)
    },
    decMonth() {
      if (this.month - 1 < 0) {
        this.month = 11
        this.cYear -= 1
        this.selectMonth(this.month)
      } else {
        this.month -= 1
        this.selectMonth(this.month)
      }
    },
    selectMonth(index) {
      this.$emit('update:value', index)
      this.$emit('update:year', this.cYear)
      this.$emit('change')
      this.datePicker = false
    },
  },
}
</script>

<style scoped lang="scss">
.c-month-picker {
  .shadow {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
  }
  .date-place-wrap {
    position: relative;
    min-width: 220px;
    margin-left:15px;
  }
  .date-picker-place {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border: 1px solid var(--primary);
    border-radius: 12px;
    width: 100%;

    .icon {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
      }
    }


    .title-place {
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      font-size: 16px;
      font-weight: 700;
      color: var(--primary);

      .image-place {
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .month-picker-popover {
    position: absolute;
    top: calc(100% + 10px);
    left: 16px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    width: 360px;
    z-index: 1000;

    .top-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
      font-size: 18px;
      margin-bottom: 20px;

      .arrow {
        cursor: pointer;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .year {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .month-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .month-cell {
        cursor: pointer;
        border-radius: 6px;
        font-size: 16px;
        transition: all 0.2s ease;

        &.active {
          color: var(--primary);
          font-weight: bold;
        }

        &:hover {
          background: #f0f0f0;
        }
      }
    }
  }
  
}
</style>
